import { BaseStudioApi } from "../BaseStudioApi";

export class Base3DApi extends BaseStudioApi { }
